export default {
    //中文
    DiagnosticReport:'诊断报告',
    troubleCode:'故障码',
    time:'时间',
    noTItle:'制造商控制',
    TestReport:'测试报告',
    VehicleInformation:'车辆信息',
    DataStream:'数据流',
    IMReadiness:'I/M准备就绪',
    Communication:'通信协议',
    notFaultCode:'无故障码',
    nodataflow:'无异常数据流',
    PositioningPrompt:'开启定位功能以获取当地价格。',
    FaultCode:'故障代码',
    AIDiagnosis:'AI诊断',
    AIWait:'AI报告或等待自动诊断',
    FailedFaultCode:'无法获取故障代码信息',
    AIError:'AI分析失败',
    more:'更多',
    StoredCodes:'确认故障码',
    PendingCodes:'等待故障码',
    PermanentCodes:'永久故障码',
    ManufacturerControl:'由汽车厂家定义',
    continue:'继续',
    // 引导定位
    notlimits:'无法获取位置权限',
    setupSteps:'设置步骤：',
    openset:'打开"设置"应用',
    findSet:'找到您使用的应用',
    clickset:'点击"位置"',
    selectLimits:'选择"使用期间"或"始终"',
    blackRefresh:'返回应用刷新页面',
    openAppSet:'点击"应用管理"或"应用"',
    findUseBrowser:'找到您使用的浏览器',
    clickAuthority:'点击"权限管理"',
    findejurisd:'找到"位置"权限',
    selectjurisd:'选择"允许"或"使用时允许"',
    phoneJurisd:'检查手机应用的定位权限：',
    openJurisd:'开启"位置"权限',
    report:'报告',
    AI:'AI',
    Freeze:'冻结帧',
    VoltageInfo:'电压信息',
    Voltage:'电压',
    Agent:'Agent',
    think:'深度思考中'
}